<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="公司名" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search"> 查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        height="100%"
        :data="results"
        highlight-current-row
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="id" label="id" width="100" />
        <el-table-column prop="name" label="名称" />
        <el-table-column prop="logo" label="logo">
          <template slot-scope="scope">
            <img :src="scope.row.logo" style="width: 100px" />
          </template>
        </el-table-column>
        <el-table-column prop="website" label="官网" />
        <el-table-column prop="introduction" label="介绍" />
        <el-table-column prop="size" label="规模">
          <template slot-scope="scope">
            {{ companySizeMap[scope.row.size] }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            {{ {0: "正常", 1: "删除", 2: "待审核"}[scope.row.status] }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-dropdown size="mini" trigger="hover" placement="bottom" @command="handleCommand">
              <el-button type="primary">
                操作<i class="el-icon-arrow-down el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item divided :command="{ cmd: 'view', row: scope.row }">
                  详情
                </el-dropdown-item>
                <el-dropdown-item divided :command="{ cmd: 'edit', row: scope.row }">
                  编辑
                </el-dropdown-item>
                <el-dropdown-item
                  :disabled="scope.row.status === 0 "
                  divided
                  :command="{ cmd: 'certify', row: scope.row }"
                >
                  通过
                </el-dropdown-item>

                <el-dropdown-item
                  :disabled="scope.row.status === 0 || scope.row.status === 1"
                  divided
                  :command="{ cmd: 'refuse', row: scope.row }"
                >
                  退回
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>

<!--    <el-dialog :visible.sync="viewVisible" :close-on-click-modal="false" title="详情">-->
<!--      <el-descriptions column="1" size="mini">-->
<!--        <el-descriptions-item label="companyId">{{ viewCompany.id }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="name">{{ viewCompany.name }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="website">{{ viewCompany.website }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="introduction">{{ viewCompany.introduction }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="size">{{ companySizeMap[viewCompany.size] }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="contractAddress">{{ viewCompany.contractAddress }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="hotWalletAddress">{{ viewCompany.hotWalletAddress }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="chains">{{ viewCompany.chains }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="twitter">{{ viewCompany.twitter }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="discord">{{ viewCompany.discord }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="telegram">{{ viewCompany.telegram }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="medium">{{ viewCompany.medium }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="github">{{ viewCompany.github }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="mirror">{{ viewCompany.mirror }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="email">{{ viewCompany.email }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="base">{{ viewCompany.base }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="projectCategory">{{ viewCompany.projectCategory }}</el-descriptions-item>-->
<!--        <el-descriptions-item label="slogan">{{ viewCompany.slogan }}</el-descriptions-item>-->
<!--      </el-descriptions>-->
<!--      <div slot="footer" class="dialog-footer">-->
<!--        <el-button @click.native="viewVisible = false"> 取消</el-button>-->
<!--      </div>-->
<!--    </el-dialog>-->

    <el-dialog :visible.sync="viewVisible" :close-on-click-modal="false" title="详情">
      <!-- 原始数据部分 -->
      <h3>原始数据</h3>
      <el-descriptions column="1" size="mini">
        <el-descriptions-item label="companyId">{{ OriginalCompany.id }}</el-descriptions-item>
        <el-descriptions-item label="name">{{ OriginalCompany.name }}</el-descriptions-item>
        <el-descriptions-item label="website">{{ OriginalCompany.website }}</el-descriptions-item>
        <el-descriptions-item label="introduction">{{ OriginalCompany.introduction }}</el-descriptions-item>
        <el-descriptions-item label="size">{{ companySizeMap[OriginalCompany.size] }}</el-descriptions-item>
        <el-descriptions-item label="contractAddress">{{ OriginalCompany.contractAddress }}</el-descriptions-item>
        <el-descriptions-item label="hotWalletAddress">{{ OriginalCompany.hotWalletAddress }}</el-descriptions-item>
        <el-descriptions-item label="chains">{{ OriginalCompany.chains }}</el-descriptions-item>
        <el-descriptions-item label="twitter">{{ OriginalCompany.twitter }}</el-descriptions-item>
        <el-descriptions-item label="discord">{{ OriginalCompany.discord }}</el-descriptions-item>
        <el-descriptions-item label="telegram">{{ OriginalCompany.telegram }}</el-descriptions-item>
        <el-descriptions-item label="medium">{{ OriginalCompany.medium }}</el-descriptions-item>
        <el-descriptions-item label="github">{{ OriginalCompany.github }}</el-descriptions-item>
        <el-descriptions-item label="mirror">{{ OriginalCompany.mirror }}</el-descriptions-item>
        <el-descriptions-item label="email">{{ OriginalCompany.email }}</el-descriptions-item>
        <el-descriptions-item label="base">{{ OriginalCompany.base }}</el-descriptions-item>
        <el-descriptions-item label="projectCategory">{{ OriginalCompany.projectCategory }}</el-descriptions-item>
        <el-descriptions-item label="slogan">{{ OriginalCompany.slogan }}</el-descriptions-item>
      </el-descriptions>

      <!-- 修改数据部分 -->
      <h3>修改数据</h3>

      <el-descriptions column="1" size="mini">
        <el-descriptions-item label="companyId">
      <span :class="{ 'highlight': OriginalCompany.id !== viewCompany.id }">
        {{ viewCompany.id }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="name">
      <span :class="{ 'highlight': OriginalCompany.name !== viewCompany.name }">
        {{ viewCompany.name }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="website">
      <span :class="{ 'highlight': OriginalCompany.website !== viewCompany.website }">
        {{ viewCompany.website }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="introduction">
      <span :class="{ 'highlight': OriginalCompany.introduction !== viewCompany.introduction }">
        {{ viewCompany.introduction }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="size">
      <span :class="{ 'highlight': OriginalCompany.size !== viewCompany.size }">
        {{ companySizeMap[viewCompany.size] }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="contractAddress">
      <span :class="{ 'highlight': OriginalCompany.contractAddress !== viewCompany.contractAddress }">
        {{ viewCompany.contractAddress }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="hotWalletAddress">
      <span :class="{ 'highlight': OriginalCompany.hotWalletAddress !== viewCompany.hotWalletAddress }">
        {{ viewCompany.hotWalletAddress }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="chains">
      <span :class="{ 'highlight': OriginalCompany.chains !== viewCompany.chains }">
        {{ viewCompany.chains }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="twitter">
      <span :class="{ 'highlight': OriginalCompany.twitter !== viewCompany.twitter }">
        {{ viewCompany.twitter }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="discord">
      <span :class="{ 'highlight': OriginalCompany.discord !== viewCompany.discord }">
        {{ viewCompany.discord }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="telegram">
      <span :class="{ 'highlight': OriginalCompany.telegram !== viewCompany.telegram }">
        {{ viewCompany.telegram }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="medium">
      <span :class="{ 'highlight': OriginalCompany.medium !== viewCompany.medium }">
        {{ viewCompany.medium }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="github">
      <span :class="{ 'highlight': OriginalCompany.github !== viewCompany.github }">
        {{ viewCompany.github }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="mirror">
      <span :class="{ 'highlight': OriginalCompany.mirror !== viewCompany.mirror }">
        {{ viewCompany.mirror }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="email">
      <span :class="{ 'highlight': OriginalCompany.email !== viewCompany.email }">
        {{ viewCompany.email }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="base">
      <span :class="{ 'highlight': OriginalCompany.base !== viewCompany.base }">
        {{ viewCompany.base }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="projectCategory">
      <span :class="{ 'highlight': OriginalCompany.projectCategory !== viewCompany.projectCategory }">
        {{ viewCompany.projectCategory }}
      </span>
        </el-descriptions-item>
        <el-descriptions-item label="slogan">
      <span :class="{ 'highlight': OriginalCompany.slogan !== viewCompany.slogan }">
        {{ viewCompany.slogan }}
      </span>
        </el-descriptions-item>
      </el-descriptions>


      <div slot="footer" class="dialog-footer">
        <el-button @click="viewVisible = false">取消</el-button>
      </div>
    </el-dialog>


    <el-dialog :visible.sync="editFormVisible" :close-on-click-modal="false" title="编辑">
      <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name" />
        </el-form-item>
        <el-form-item label="介绍" prop="introduction">
          <el-input v-model="editForm.introduction" />
        </el-form-item>
        <el-form-item label="官网" prop="website">
          <el-input v-model="editForm.website" />
        </el-form-item>
        <el-form-item label="规模" prop="size">
          <el-select v-model="editForm.size" placeholder="请选择">
            <el-option
              v-for="item in companySizeList"
              :key="item.settingId"
              :label="item.name"
              :value="item.settingId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合约地址" prop="contractAddress">
          <el-input v-model="editForm.contractAddress" />
        </el-form-item>
        <el-form-item label="热钱包地址" prop="hotWalletAddress">
          <el-input v-model="editForm.hotWalletAddress" />
        </el-form-item>
        <el-form-item label="支持的链" prop="chains">
          <el-input v-model="editForm.chains" />
        </el-form-item>
        <el-form-item label="twitter" prop="twitter">
          <el-input v-model="editForm.twitter" />
        </el-form-item>
        <el-form-item label="discord" prop="discord">
          <el-input v-model="editForm.discord" />
        </el-form-item>
        <el-form-item label="telegram" prop="telegram">
          <el-input v-model="editForm.telegram" />
        </el-form-item>
        <el-form-item label="medium" prop="medium">
          <el-input v-model="editForm.medium" />
        </el-form-item>
        <el-form-item label="github" prop="github">
          <el-input v-model="editForm.github" />
        </el-form-item>
        <el-form-item label="mirror" prop="mirror">
          <el-input v-model="editForm.mirror" />
        </el-form-item>
        <el-form-item label="email" prop="email">
          <el-input v-model="editForm.email" />
        </el-form-item>
        <el-form-item label="工作地点" prop="base">
          <el-input v-model="editForm.base" />
        </el-form-item>
        <el-form-item label="项目标签" prop="projectCategory">
          <el-input v-model="editForm.projectCategory" />
        </el-form-item>
        <el-form-item label="Slogan" prop="slogan">
          <el-input v-model="editForm.slogan" />
        </el-form-item>
        <el-form-item label="logo" prop="logo">
          <el-form-item label="图标">
            <upload v-model="editForm.logo" />
          </el-form-item>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false"> 取消</el-button>
        <el-button :loading="editLoading" type="primary" @click.native="editSubmit">
          提交
        </el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";
import Upload from "@/components/Upload";

export default {
  components: { Upload },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addFormRules: {},
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editFormRules: {},
      editLoading: false,
      companySizeMap: {},
      companySizeList: [],
      viewVisible: false,
      viewCompany: {},
      OriginalCompany: {},
    };
  },
  mounted() {
    mainHeight(this);
    this.getSettings();
    this.list();
  },
  methods: {
    search() {
      this.page.page = 1;
      this.list();
    },
    getSettings() {
      const me = this;
      const params = { lang: "cn" };
      this.axios
        .get("/api/setting/settings", params)
        .then((data) => {
          this.companySizeList = data.companySize;
          for (var i = 0; i < data.companySize.length; i++) {
            this.companySizeMap[data.companySize[i].settingId] = data.companySize[i].name;
          }
        })
        .finally(() => {
          me.listLoading = false;
        });
    },
    list() {
      const me = this;
      me.listLoading = true;
      const params = Object.assign(me.filters, {
        page: me.page.page,
        limit: me.page.limit,
      });
      this.axios
        .form("/api/admin/edit-company/list", params)
        .then((data) => {
          me.results = data.results;
          me.page = data.page;
        })
        .finally(() => {
          me.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    handleEdit(row) {
      const me = this;
      this.axios
        .get(`/api/admin/edit-company/${row.id}`)
        .then((data) => {
          me.editForm = Object.assign({}, data);
          me.editFormVisible = true;
        })
        .catch((rsp) => {
          me.$notify.error({ title: "错误", message: rsp.message });
        });
    },
    view(row) {
      const me = this;
      Promise.all([
        this.axios.get(`/api/admin/company/${row.id}`),
        this.axios.get(`/api/admin/edit-company/${row.id}`)
      ])
        .then(([originalData, modifiedData]) => {
          me.OriginalCompany = Object.assign({}, originalData);
          me.viewCompany = Object.assign({}, modifiedData);
          me.viewVisible = true;

        })
        .catch((error) => {
          me.$notify.error({ title: "错误", message: error.message });
        });

    },
    editSubmit() {
      const me = this;
      this.axios
        .form("/api/admin/edit-company/update", this.editForm)
        .then((data) => {
          me.list();
          me.editFormVisible = false;
        })
        .catch((rsp) => {
          me.$notify.error({ title: "错误", message: rsp.message });
        });
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    certify(row) {
      const me = this;
      const params = {
        id: row.id,
      };
      this.$confirm("是否通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          me.axios
            .form("/api/admin/edit-company/certify", params)
            .then(function () {
              me.$message({ message: "审核成功", type: "success" });
              me.list();
            })
            .catch((rsp) => {
              me.$notify.error({ title: "错误", message: rsp.message });
            });
        })
        .catch(function () {
          me.$message({
            type: "info",
            message: "已取消审核",
          });
        });
    },
    refuse(row) {
      const me = this;
      const params = {
        id: row.id,
      };

      this.$prompt("请输入退回理由", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "退回理由",
        inputValidator: (value) => !!value || "退回理由不能为空",
      })
        .then(({ value }) => {
          params.reason = value;  // 添加退回理由到参数

          this.$confirm("是否退回?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(function () {
              me.axios
                .form("/api/admin/edit-company/refuse", params)
                .then(function () {
                  me.$message({ message: "退回成功", type: "success" });
                  me.list();
                })
                .catch((rsp) => {
                  me.$notify.error({ title: "错误", message: rsp.message });
                });
            })
            .catch(function () {
              me.$message({
                type: "info",
                message: "已取消退回",
              });
            });
        })
        .catch(() => {
          me.$message({
            type: "info",
            message: "已取消退回",
          });
        });
    },
    handleCommand(cmd) {
      if (cmd.cmd === "edit") {
        this.handleEdit(cmd.row);
      } else if (cmd.cmd === "certify") {
        this.certify(cmd.row);
      } else if (cmd.cmd === "view") {
        this.view(cmd.row);
      } else if (cmd.cmd === "refuse") {
        this.refuse(cmd.row);
      }
    },
  },
};
</script>

<style>
.highlight {
  color: #f56c6c !important; /* 高亮的颜色 */
}
</style>
